var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기본정보" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [_c("q-btn-group", { attrs: { outline: "" } })],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.completeDisabled,
                        label: "순회일",
                        name: "patrolStartDate",
                      },
                      on: { datachange: _vm.datachangeDate },
                      model: {
                        value: _vm.patrol.patrolStartDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.patrol, "patrolStartDate", $$v)
                        },
                        expression: "patrol.patrolStartDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        label: "순회명",
                        name: "patrolName",
                      },
                      model: {
                        value: _vm.patrol.patrolName,
                        callback: function ($$v) {
                          _vm.$set(_vm.patrol, "patrolName", $$v)
                        },
                        expression: "patrol.patrolName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-dept", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        label: "점검주관부서",
                        name: "deptCd",
                      },
                      on: {
                        setDeptName: (deptName) => {
                          _vm.patrol.deptName = deptName
                        },
                      },
                      model: {
                        value: _vm.patrol.deptCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.patrol, "deptCd", $$v)
                        },
                        expression: "patrol.deptCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                  },
                  [
                    _c("c-multi-field", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        data: _vm.patrol,
                        disabled: _vm.disabled,
                        label: "점검자",
                        type: "user",
                        name: "checkUserId",
                      },
                      model: {
                        value: _vm.patrol.checkUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.patrol, "checkUserId", $$v)
                        },
                        expression: "patrol.checkUserId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      on: { datachange: _vm.datachange },
                      model: {
                        value: _vm.patrol.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.patrol, "plantCd", $$v)
                        },
                        expression: "patrol.plantCd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-mobile-table",
            {
              ref: "table",
              attrs: {
                isTitle: "",
                title: "순회 장소 목록",
                columns: _vm.grid.columns,
                gridHeight: _vm.gridHeight,
                data: _vm.patrol.places,
                gridHeightAuto: true,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                hideBottom: true,
                editable: _vm.editable && !_vm.disabled,
                rowKey: "saiPatrolPlaceId",
                selection: "multiple",
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      props.row.lines && props.row.lines.length > 0
                        ? _vm._l(props.row.lines, function (line, index) {
                            return _c(
                              "q-chip",
                              {
                                key: index,
                                staticClass: "q-ma-none customchipdept",
                                attrs: {
                                  outline: "",
                                  square: "",
                                  removable: !_vm.disabled && _vm.editable,
                                  color: "primary",
                                  "text-color": "white",
                                },
                                on: {
                                  remove: function ($event) {
                                    return _vm.removeLine(props.row, line)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(line.lineCd) + " ")]
                            )
                          })
                        : _vm._e(),
                      _vm.editable && !_vm.disabled
                        ? _c(
                            "q-chip",
                            {
                              attrs: {
                                clickable: "",
                                color: "primary",
                                "text-color": "white",
                                icon: "add",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addLine(props, col)
                                },
                              },
                            },
                            [_vm._v(" 추가 ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _vm.editable && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              disabled:
                                !_vm.patrol.places ||
                                _vm.patrol.places.length === 0,
                              label: "",
                              icon: "remove",
                            },
                            on: { btnClicked: _vm.removePlace },
                          })
                        : _vm._e(),
                      _vm.editable && !_vm.disabled
                        ? _c("c-btn", {
                            attrs: {
                              showLoading: false,
                              label: "",
                              icon: "add",
                            },
                            on: { btnClicked: _vm.addPlace },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.patrol.patrolStepCd === "PS00000010",
                      expression: "patrol.patrolStepCd === 'PS00000010'",
                    },
                  ],
                  attrs: { flat: true, label: "출력", icon: "print" },
                  on: { btnClicked: _vm.printPatrol },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOld && !_vm.deleteDisabled && _vm.editable,
                      expression: "isOld && !deleteDisabled && editable",
                    },
                  ],
                  attrs: { flat: true, label: "삭제", icon: "delete_forever" },
                  on: { btnClicked: _vm.removePlan },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.completeDisabled && _vm.editable,
                      expression: "!completeDisabled && editable",
                    },
                  ],
                  attrs: {
                    flat: true,
                    url: _vm.saveUrl,
                    isSubmit: _vm.isSave,
                    param: _vm.patrol,
                    mappingType: _vm.actionType,
                    label: "저장",
                    icon: "save",
                  },
                  on: {
                    beforeAction: _vm.savePlan,
                    btnCallback: _vm.saveCallback,
                  },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOld && !_vm.disabled && _vm.editable,
                      expression: "isOld && !disabled && editable",
                    },
                  ],
                  attrs: {
                    flat: true,
                    url: _vm.completeUrl,
                    isSubmit: _vm.isComplete,
                    param: _vm.patrol,
                    mappingType: "PUT",
                    label: "완료",
                    icon: "check",
                  },
                  on: {
                    beforeAction: _vm.completePlan,
                    btnCallback: _vm.completeCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }